export default __webpack_public_path__ + "static/media/ictaes.437dc543.png";